import Id from '@/utils/Id'

export const SERVER_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ssZZ'
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD'
export const SERVER_TIME_FORMAT = 'HH:mm:ssZZ'

export const createDeskEvent = () => {
  return {
    id: Id(),
    desk_id: null,
    employee_id: null,
    set_id: null,
    start: null,
    end: null,
    remind: null
  }
}
